export default "__VITE_ASSET__BuL_SQzG__"